import { render } from "./FilterCategory.vue?vue&type=template&id=1dacde58&scoped=true"
import script from "./FilterCategory.vue?vue&type=script&lang=js"
export * from "./FilterCategory.vue?vue&type=script&lang=js"

import "./FilterCategory.vue?vue&type=style&index=0&id=1dacde58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dacde58"]])

export default __exports__